// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateShopCategoryRequestModel from '../../model/update-shop-category-request-model';
import UpdateShopCategoryRequestDTO from '../dto/update-shop-category-request-dto';
import dtoSchema from '../schemas/update-shop-category-request-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class UpdateShopCategoryRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateShopCategoryRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.parentCategoryId = data.parentCategoryId ?? undefined;
      this.caption = data.caption ?? undefined;
      this.sort = data.sort ?? undefined;
      this.translatedLanguage_ISO2 = data.translatedLanguage_ISO2;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  parentCategoryId?: number;
  /**
  */
  caption?: string;
  /**
  * @type {int32}
  */
  sort?: number;
  /**
  * @minimum 1
  */
  translatedLanguage_ISO2?: string;

  static toModel(dto: DeepPartial<UpdateShopCategoryRequestDTO>): UpdateShopCategoryRequestModel;
  static toModel(dto: DeepPartial<UpdateShopCategoryRequestDTO> | undefined | null): UpdateShopCategoryRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateShopCategoryRequestDTO> | undefined | null): UpdateShopCategoryRequestModel | undefined {
    return dto ? new UpdateShopCategoryRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateShopCategoryRequestModel> | UpdateShopCategoryRequestModel): UpdateShopCategoryRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      parentCategoryId: unwrapped.parentCategoryId,
      caption: unwrapped.caption,
      sort: unwrapped.sort,
      translatedLanguage_ISO2: unwrapped.translatedLanguage_ISO2,
    } as UpdateShopCategoryRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateShopCategoryRequestModel, can not map to UpdateShopCategoryRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
